import React, { PureComponent } from "react";
import {
  Button,
  CardBody,
  Split,
  Wrapper,
  Stretch,
  Title,
  Copy,
  Icon,
  CenterCenter
} from "app/NativeComponents/common";

import { store } from "app/store";

class Select extends PureComponent {
  renderCopy(text, size) {
    if (size === "small") {
      if (text && text != "") {
        return <Copy style={{ fontSize: 14 }}>{text}</Copy>;
      } else {
        return <Copy style={{ fontSize: 14 }}>Not selected</Copy>;
      }
    }

    if (text && text != "") {
      return <Title>{text}</Title>;
    } else {
      return <Title>Not selected</Title>;
    }
  }

  renderSelect(items, value, onSelect) {
    return (
      <select value={value} onChange={ev => onSelect(ev.target.value)}>
        {items.map((item, i) => {
          if (item.value == value) {
            return (
              <option defaultValue key={i} value={item.value}>
                {item.label}
              </option>
            );
          }
          return (
            <option key={i} value={item.value}>
              {item.label}
            </option>
          );
        })}
      </select>
    );
  }

  render() {
    const {
      style,
      item_ref,
      title,
      text,
      label,
      value,
      onSelect,
      items,
      size
    } = this.props;

    const colors = store.getState().settings.colors;

    if (size == "small") {
      return (
        <Wrapper>
          <div className="dm-select-wrapper">
            <Wrapper style={{ ...style }}>
              <Split
                style={{
                  flex: 1
                }}
              >
                <Stretch>
                  <Copy style={{ fontSize: 10, lineHeight: "10px" }}>
                    {title}
                  </Copy>
                  {this.renderCopy(text, size)}
                </Stretch>
                <Wrapper>
                  <CenterCenter>
                    <Icon
                      style={{ marginLeft: 15 }}
                      color={colors.light_text_color}
                      fa_icon="sort"
                      size={10}
                    />
                  </CenterCenter>
                </Wrapper>
              </Split>
            </Wrapper>
            {this.renderSelect(items, value, onSelect)}
          </div>
        </Wrapper>
      );
    }

    return (
      <Wrapper>
        <div className="dm-select-wrapper">
          <CardBody style={style}>
            <Split
              style={{
                flex: 1
              }}
            >
              <Stretch>
                <Copy>{title}</Copy>
                {this.renderCopy(text)}
              </Stretch>
              <Wrapper>
                <CenterCenter>
                  <Icon
                    style={{ marginLeft: 10 }}
                    size={14}
                    color={colors.light_text_color}
                    fa_icon="sort"
                  />
                </CenterCenter>
              </Wrapper>
            </Split>
          </CardBody>
          {this.renderSelect(items, value, onSelect)}
        </div>
      </Wrapper>
    );
  }
}

export { Select };
